import process from 'process/browser'

export { process }
